<template>
  <div>
    <q-dialog ref="dialog" @hide="onDialogHide">
      <q-card class="q-dialog-plugin">
        <q-card-section class="row justify-center">
          <q-icon name="mail_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
         <q-form
            @submit="()=>{
              this.$emit('on-ok-click', email)
            }"
            class="q-gutter-md"
        >
            <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">
                <translate>CONFIRM_SEND_EMAIL_INCOICE</translate>
            </span>
            <q-input v-model="email" style="width:100%" :rules="[val => validateEmail(val)]" input-id="fixed-email-input"/>
            </q-card-section>
            <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn
                :label="$gettext('CANCEL')"
                color="grey-7"
                @click="onCancelClick"
                class="q-px-lg"
            />
            <q-btn
                id="confirm-button"
                :label="$gettext('CONFIRM')"
                color="info"
                type="submit"
                class="q-px-lg"
            />
            </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { QDialog, Dialog } from 'quasar'
import { Component, Vue } from 'vue-property-decorator'
import { validate } from 'vue-convenia-util'

@Component({
  name: 'sendEmailInvoiceDialog',
  components: {
    QDialog,
    Dialog,
    validate
  },
  props: {
    emailServiceRequest: String
  }
})
class SendEmailInvoiceDialog extends Vue {
  email = '';
  mounted () {
    this.email = this.emailServiceRequest
  }

  show () {
    this.$refs.dialog.show()
  }

  validateEmail (value) {
    const regex = /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i
    return !!value.match(regex)
  }

  hide () {
    this.$refs.dialog.hide()
  }

  onDialogHide () {
    this.$emit('hide')
  }

  onOKClick () {
    this.$emit('ok', this.email)
    this.hide()
  }

  onCancelClick () {
    this.hide()
  }
}
export default SendEmailInvoiceDialog
</script>
<style lang="stylus" scoped>
</style>
